"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListMyAccessibleChartsInAnOrgFromDirectoryControllerSortDateAppointmentPretestEnum = exports.DirectoryApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var DirectoryApi = /** @class */ (function (_super) {
    __extends(DirectoryApi, _super);
    function DirectoryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Checks if each MRN in the array exist in PDS for a given organization
     */
    DirectoryApi.prototype.checkMrnInOrgBulkFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
                            throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling checkMrnInOrgBulkFromDirectoryController.');
                        }
                        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
                            throw new runtime.RequiredError('requestBody', 'Required parameter requestParameters.requestBody was null or undefined when calling checkMrnInOrgBulkFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/user/me/orgs/{orgId}/check-mrn-bulk".replace("{".concat("orgId", "}"), encodeURIComponent(String(requestParameters.orgId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.requestBody,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Checks if each MRN in the array exist in PDS for a given organization
     */
    DirectoryApi.prototype.checkMrnInOrgBulkFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkMrnInOrgBulkFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new chart
     */
    DirectoryApi.prototype.createChartFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.chartCreateRequestDto === null || requestParameters.chartCreateRequestDto === undefined) {
                            throw new runtime.RequiredError('chartCreateRequestDto', 'Required parameter requestParameters.chartCreateRequestDto was null or undefined when calling createChartFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/charts",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ChartCreateRequestDtoToJSON)(requestParameters.chartCreateRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChartResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new chart
     */
    DirectoryApi.prototype.createChartFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createChartFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates new patient chart in PDS
     */
    DirectoryApi.prototype.createChartsInOrgFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
                            throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling createChartsInOrgFromDirectoryController.');
                        }
                        if (requestParameters.createChartRequestDto === null || requestParameters.createChartRequestDto === undefined) {
                            throw new runtime.RequiredError('createChartRequestDto', 'Required parameter requestParameters.createChartRequestDto was null or undefined when calling createChartsInOrgFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/user/me/orgs/{orgId}/charts".replace("{".concat("orgId", "}"), encodeURIComponent(String(requestParameters.orgId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CreateChartRequestDtoToJSON)(requestParameters.createChartRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChartDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates new patient chart in PDS
     */
    DirectoryApi.prototype.createChartsInOrgFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createChartsInOrgFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Provisions a new org
     */
    DirectoryApi.prototype.createOrgFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createOrgRequestDto === null || requestParameters.createOrgRequestDto === undefined) {
                            throw new runtime.RequiredError('createOrgRequestDto', 'Required parameter requestParameters.createOrgRequestDto was null or undefined when calling createOrgFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/orgs",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CreateOrgRequestDtoToJSON)(requestParameters.createOrgRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrgResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Provisions a new org
     */
    DirectoryApi.prototype.createOrgFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createOrgFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new resource group
     */
    DirectoryApi.prototype.createResourceGroupFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.resourceGroupCreateRequestDto === null || requestParameters.resourceGroupCreateRequestDto === undefined) {
                            throw new runtime.RequiredError('resourceGroupCreateRequestDto', 'Required parameter requestParameters.resourceGroupCreateRequestDto was null or undefined when calling createResourceGroupFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/resource-groups",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ResourceGroupCreateRequestDtoToJSON)(requestParameters.resourceGroupCreateRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ResourceGroupResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new resource group
     */
    DirectoryApi.prototype.createResourceGroupFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createResourceGroupFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new membership for resource group
     */
    DirectoryApi.prototype.createResourceGroupMembershipFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling createResourceGroupMembershipFromDirectoryController.');
                        }
                        if (requestParameters.resourceGroupsMembershipCreateRequestDto === null || requestParameters.resourceGroupsMembershipCreateRequestDto === undefined) {
                            throw new runtime.RequiredError('resourceGroupsMembershipCreateRequestDto', 'Required parameter requestParameters.resourceGroupsMembershipCreateRequestDto was null or undefined when calling createResourceGroupMembershipFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/resource-groups/{resourceGroupId}/memberships".replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ResourceGroupsMembershipCreateRequestDtoToJSON)(requestParameters.resourceGroupsMembershipCreateRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ResourceGroupResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new membership for resource group
     */
    DirectoryApi.prototype.createResourceGroupMembershipFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createResourceGroupMembershipFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a chart
     */
    DirectoryApi.prototype.deleteChartFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.chartId === null || requestParameters.chartId === undefined) {
                            throw new runtime.RequiredError('chartId', 'Required parameter requestParameters.chartId was null or undefined when calling deleteChartFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/charts/{chartId}".replace("{".concat("chartId", "}"), encodeURIComponent(String(requestParameters.chartId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete a chart
     */
    DirectoryApi.prototype.deleteChartFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteChartFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete a new org
     */
    DirectoryApi.prototype.deleteOrgFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
                            throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling deleteOrgFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/orgs/{orgId}".replace("{".concat("orgId", "}"), encodeURIComponent(String(requestParameters.orgId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete a new org
     */
    DirectoryApi.prototype.deleteOrgFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteOrgFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete a resource group
     */
    DirectoryApi.prototype.deleteResourceGroupFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling deleteResourceGroupFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/resource-groups/{resourceGroupId}".replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete a resource group
     */
    DirectoryApi.prototype.deleteResourceGroupFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteResourceGroupFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete a membership from resource group
     */
    DirectoryApi.prototype.deleteResourceGroupMembershipFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling deleteResourceGroupMembershipFromDirectoryController.');
                        }
                        if (requestParameters.membershipId === null || requestParameters.membershipId === undefined) {
                            throw new runtime.RequiredError('membershipId', 'Required parameter requestParameters.membershipId was null or undefined when calling deleteResourceGroupMembershipFromDirectoryController.');
                        }
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling deleteResourceGroupMembershipFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/resource-groups/{resourceGroupId}/memberships/{membershipId}/remove/{userId}".replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))).replace("{".concat("membershipId", "}"), encodeURIComponent(String(requestParameters.membershipId))).replace("{".concat("userId", "}"), encodeURIComponent(String(requestParameters.userId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete a membership from resource group
     */
    DirectoryApi.prototype.deleteResourceGroupMembershipFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteResourceGroupMembershipFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get chart details of a single chart
     */
    DirectoryApi.prototype.getChartDetailsFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
                            throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling getChartDetailsFromDirectoryController.');
                        }
                        if (requestParameters.chartId === null || requestParameters.chartId === undefined) {
                            throw new runtime.RequiredError('chartId', 'Required parameter requestParameters.chartId was null or undefined when calling getChartDetailsFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/user/me/orgs/{orgId}/charts/{chartId}".replace("{".concat("orgId", "}"), encodeURIComponent(String(requestParameters.orgId))).replace("{".concat("chartId", "}"), encodeURIComponent(String(requestParameters.chartId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChartDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get chart details of a single chart
     */
    DirectoryApi.prototype.getChartDetailsFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getChartDetailsFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets details of an chart
     */
    DirectoryApi.prototype.getChartFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.chartId === null || requestParameters.chartId === undefined) {
                            throw new runtime.RequiredError('chartId', 'Required parameter requestParameters.chartId was null or undefined when calling getChartFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/charts/{chartId}".replace("{".concat("chartId", "}"), encodeURIComponent(String(requestParameters.chartId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChartResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets details of an chart
     */
    DirectoryApi.prototype.getChartFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getChartFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets list of charts
     */
    DirectoryApi.prototype.getChartsFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.page === null || requestParameters.page === undefined) {
                            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getChartsFromDirectoryController.');
                        }
                        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
                            throw new runtime.RequiredError('pageSize', 'Required parameter requestParameters.pageSize was null or undefined when calling getChartsFromDirectoryController.');
                        }
                        queryParameters = {};
                        if (requestParameters.startsWithQuery !== undefined) {
                            queryParameters['startsWithQuery'] = requestParameters.startsWithQuery;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        if (requestParameters.firstName !== undefined) {
                            queryParameters['firstName'] = requestParameters.firstName;
                        }
                        if (requestParameters.lastName !== undefined) {
                            queryParameters['lastName'] = requestParameters.lastName;
                        }
                        if (requestParameters.email !== undefined) {
                            queryParameters['email'] = requestParameters.email;
                        }
                        if (requestParameters.orgId !== undefined) {
                            queryParameters['orgId'] = requestParameters.orgId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/charts",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaginatedChartsListResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets list of charts
     */
    DirectoryApi.prototype.getChartsFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getChartsFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Metadata about the practitioner directory structure
     */
    DirectoryApi.prototype.getMyMetadataAsPractitionerFromDirectoryControllerRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/user/me",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.UserInfoResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Metadata about the practitioner directory structure
     */
    DirectoryApi.prototype.getMyMetadataAsPractitionerFromDirectoryController = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMyMetadataAsPractitionerFromDirectoryControllerRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List of organization that the user is part of.
     */
    DirectoryApi.prototype.getMyOrganizationsFromDirectoryControllerRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/me/organizations",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.MyOrganizationResponseFromJSON); })];
                }
            });
        });
    };
    /**
     * List of organization that the user is part of.
     */
    DirectoryApi.prototype.getMyOrganizationsFromDirectoryController = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMyOrganizationsFromDirectoryControllerRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets details of an org
     */
    DirectoryApi.prototype.getOrgFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
                            throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling getOrgFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/orgs/{orgId}".replace("{".concat("orgId", "}"), encodeURIComponent(String(requestParameters.orgId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrgsDataResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets details of an org
     */
    DirectoryApi.prototype.getOrgFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrgFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets list of orgs
     */
    DirectoryApi.prototype.getOrgsFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.page === null || requestParameters.page === undefined) {
                            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getOrgsFromDirectoryController.');
                        }
                        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
                            throw new runtime.RequiredError('pageSize', 'Required parameter requestParameters.pageSize was null or undefined when calling getOrgsFromDirectoryController.');
                        }
                        queryParameters = {};
                        if (requestParameters.startsWithQuery !== undefined) {
                            queryParameters['startsWithQuery'] = requestParameters.startsWithQuery;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        if (requestParameters.idIn) {
                            queryParameters['idIn'] = requestParameters.idIn;
                        }
                        if (requestParameters.ordering !== undefined) {
                            queryParameters['ordering'] = requestParameters.ordering;
                        }
                        if (requestParameters.parentId !== undefined) {
                            queryParameters['parentId'] = requestParameters.parentId;
                        }
                        if (requestParameters.practiceId !== undefined) {
                            queryParameters['practiceId'] = requestParameters.practiceId;
                        }
                        if (requestParameters.practiceIdIn) {
                            queryParameters['practiceIdIn'] = requestParameters.practiceIdIn;
                        }
                        if (requestParameters.resourceType !== undefined) {
                            queryParameters['resourceType'] = requestParameters.resourceType;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/orgs",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaginatedOrgListResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets list of orgs
     */
    DirectoryApi.prototype.getOrgsFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrgsFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List of practice memberships.
     */
    DirectoryApi.prototype.getPracticeMembershipsFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.practiceId === null || requestParameters.practiceId === undefined) {
                            throw new runtime.RequiredError('practiceId', 'Required parameter requestParameters.practiceId was null or undefined when calling getPracticeMembershipsFromDirectoryController.');
                        }
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling getPracticeMembershipsFromDirectoryController.');
                        }
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/me/practice/{practiceId}/{resourceGroupId}/memberships".replace("{".concat("practiceId", "}"), encodeURIComponent(String(requestParameters.practiceId))).replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaginatedPracticeResourceGroupMembershipsListResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * List of practice memberships.
     */
    DirectoryApi.prototype.getPracticeMembershipsFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPracticeMembershipsFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets details of an resource group
     */
    DirectoryApi.prototype.getResourceGroupFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling getResourceGroupFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/resource-groups/{resourceGroupId}".replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ResourceGroupResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets details of an resource group
     */
    DirectoryApi.prototype.getResourceGroupFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getResourceGroupFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets list of memberships from a resource group
     */
    DirectoryApi.prototype.getResourceGroupMembershipsFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling getResourceGroupMembershipsFromDirectoryController.');
                        }
                        if (requestParameters.page === null || requestParameters.page === undefined) {
                            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getResourceGroupMembershipsFromDirectoryController.');
                        }
                        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
                            throw new runtime.RequiredError('pageSize', 'Required parameter requestParameters.pageSize was null or undefined when calling getResourceGroupMembershipsFromDirectoryController.');
                        }
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        if (requestParameters.name !== undefined) {
                            queryParameters['name'] = requestParameters.name;
                        }
                        if (requestParameters.idIn) {
                            queryParameters['idIn'] = requestParameters.idIn;
                        }
                        if (requestParameters.ordering !== undefined) {
                            queryParameters['ordering'] = requestParameters.ordering;
                        }
                        if (requestParameters.parentId !== undefined) {
                            queryParameters['parentId'] = requestParameters.parentId;
                        }
                        if (requestParameters.practiceId !== undefined) {
                            queryParameters['practiceId'] = requestParameters.practiceId;
                        }
                        if (requestParameters.practiceIdIn) {
                            queryParameters['practiceIdIn'] = requestParameters.practiceIdIn;
                        }
                        if (requestParameters.resourceType !== undefined) {
                            queryParameters['resourceType'] = requestParameters.resourceType;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/resource-groups/{resourceGroupId}/memberships".replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaginatedResourceGroupMembershipsListResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets list of memberships from a resource group
     */
    DirectoryApi.prototype.getResourceGroupMembershipsFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getResourceGroupMembershipsFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets list of resource groups
     */
    DirectoryApi.prototype.getResourceGroupsFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.page === null || requestParameters.page === undefined) {
                            throw new runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling getResourceGroupsFromDirectoryController.');
                        }
                        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
                            throw new runtime.RequiredError('pageSize', 'Required parameter requestParameters.pageSize was null or undefined when calling getResourceGroupsFromDirectoryController.');
                        }
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        if (requestParameters.name !== undefined) {
                            queryParameters['name'] = requestParameters.name;
                        }
                        if (requestParameters.idIn) {
                            queryParameters['idIn'] = requestParameters.idIn;
                        }
                        if (requestParameters.ordering !== undefined) {
                            queryParameters['ordering'] = requestParameters.ordering;
                        }
                        if (requestParameters.parentId !== undefined) {
                            queryParameters['parentId'] = requestParameters.parentId;
                        }
                        if (requestParameters.practiceId !== undefined) {
                            queryParameters['practiceId'] = requestParameters.practiceId;
                        }
                        if (requestParameters.practiceIdIn) {
                            queryParameters['practiceIdIn'] = requestParameters.practiceIdIn;
                        }
                        if (requestParameters.resourceType !== undefined) {
                            queryParameters['resourceType'] = requestParameters.resourceType;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/resource-groups",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaginatedChartsListResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets list of resource groups
     */
    DirectoryApi.prototype.getResourceGroupsFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getResourceGroupsFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List PDS charts within an org that current user has access to.
     */
    DirectoryApi.prototype.listMyAccessibleChartsInAnOrgFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling listMyAccessibleChartsInAnOrgFromDirectoryController.');
                        }
                        queryParameters = {};
                        if (requestParameters.sortDateAppointmentPretest !== undefined) {
                            queryParameters['sortDateAppointmentPretest'] = requestParameters.sortDateAppointmentPretest;
                        }
                        if (requestParameters.filterDateAppointmentPretest !== undefined) {
                            queryParameters['filterDateAppointmentPretest'] = requestParameters.filterDateAppointmentPretest;
                        }
                        if (requestParameters.filterInviteStatus !== undefined) {
                            queryParameters['filterInviteStatus'] = requestParameters.filterInviteStatus;
                        }
                        if (requestParameters.filterNccnCriteria !== undefined) {
                            queryParameters['filterNccnCriteria'] = requestParameters.filterNccnCriteria;
                        }
                        if (requestParameters.afterChart !== undefined) {
                            queryParameters['afterChart'] = requestParameters.afterChart;
                        }
                        if (requestParameters.count !== undefined) {
                            queryParameters['count'] = requestParameters.count;
                        }
                        if (requestParameters.dob !== undefined) {
                            queryParameters['dob'] = requestParameters.dob;
                        }
                        if (requestParameters.firstName !== undefined) {
                            queryParameters['firstName'] = requestParameters.firstName;
                        }
                        if (requestParameters.lastName !== undefined) {
                            queryParameters['lastName'] = requestParameters.lastName;
                        }
                        if (requestParameters.location !== undefined) {
                            queryParameters['location'] = requestParameters.location;
                        }
                        if (requestParameters.mrn !== undefined) {
                            queryParameters['mrn'] = requestParameters.mrn;
                        }
                        if (requestParameters.ordering !== undefined) {
                            queryParameters['ordering'] = requestParameters.ordering;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.startsWithSearch !== undefined) {
                            queryParameters['startsWithSearch'] = requestParameters.startsWithSearch;
                        }
                        if (requestParameters.numOrders !== undefined) {
                            queryParameters['numOrders'] = requestParameters.numOrders;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/user/me/orgs/{id}/charts".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChartIdentifierListDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * List PDS charts within an org that current user has access to.
     */
    DirectoryApi.prototype.listMyAccessibleChartsInAnOrgFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listMyAccessibleChartsInAnOrgFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets list of pds and reqrepo practice activities
     */
    DirectoryApi.prototype.listPracticeActivitiesFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.practiceId === null || requestParameters.practiceId === undefined) {
                            throw new runtime.RequiredError('practiceId', 'Required parameter requestParameters.practiceId was null or undefined when calling listPracticeActivitiesFromDirectoryController.');
                        }
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling listPracticeActivitiesFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/practice/{practiceId}/activities".replace("{".concat("practiceId", "}"), encodeURIComponent(String(requestParameters.practiceId))).replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.PracticeActivityResponseFromJSON); })];
                }
            });
        });
    };
    /**
     * Gets list of pds and reqrepo practice activities
     */
    DirectoryApi.prototype.listPracticeActivitiesFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listPracticeActivitiesFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets list of user pds and reqrepo activities
     */
    DirectoryApi.prototype.listUserActivitiesFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling listUserActivitiesFromDirectoryController.');
                        }
                        if (requestParameters.entityType === null || requestParameters.entityType === undefined) {
                            throw new runtime.RequiredError('entityType', 'Required parameter requestParameters.entityType was null or undefined when calling listUserActivitiesFromDirectoryController.');
                        }
                        queryParameters = {};
                        if (requestParameters.entityType !== undefined) {
                            queryParameters['entityType'] = requestParameters.entityType;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/user/{userId}/activities".replace("{".concat("userId", "}"), encodeURIComponent(String(requestParameters.userId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.UserActivityResponseFromJSON); })];
                }
            });
        });
    };
    /**
     * Gets list of user pds and reqrepo activities
     */
    DirectoryApi.prototype.listUserActivitiesFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listUserActivitiesFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update an chart
     */
    DirectoryApi.prototype.updateChartFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.chartId === null || requestParameters.chartId === undefined) {
                            throw new runtime.RequiredError('chartId', 'Required parameter requestParameters.chartId was null or undefined when calling updateChartFromDirectoryController.');
                        }
                        if (requestParameters.chartUpdateRequestDto === null || requestParameters.chartUpdateRequestDto === undefined) {
                            throw new runtime.RequiredError('chartUpdateRequestDto', 'Required parameter requestParameters.chartUpdateRequestDto was null or undefined when calling updateChartFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/charts/{chartId}".replace("{".concat("chartId", "}"), encodeURIComponent(String(requestParameters.chartId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ChartUpdateRequestDtoToJSON)(requestParameters.chartUpdateRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChartUpdateRequestDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update an chart
     */
    DirectoryApi.prototype.updateChartFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateChartFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates existing chart in PDS
     */
    DirectoryApi.prototype.updateChartInOrgFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
                            throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling updateChartInOrgFromDirectoryController.');
                        }
                        if (requestParameters.chartId === null || requestParameters.chartId === undefined) {
                            throw new runtime.RequiredError('chartId', 'Required parameter requestParameters.chartId was null or undefined when calling updateChartInOrgFromDirectoryController.');
                        }
                        if (requestParameters.patchedChartRequestDto === null || requestParameters.patchedChartRequestDto === undefined) {
                            throw new runtime.RequiredError('patchedChartRequestDto', 'Required parameter requestParameters.patchedChartRequestDto was null or undefined when calling updateChartInOrgFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/user/me/orgs/{orgId}/charts/{chartId}".replace("{".concat("orgId", "}"), encodeURIComponent(String(requestParameters.orgId))).replace("{".concat("chartId", "}"), encodeURIComponent(String(requestParameters.chartId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.PatchedChartRequestDtoToJSON)(requestParameters.patchedChartRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChartDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates existing chart in PDS
     */
    DirectoryApi.prototype.updateChartInOrgFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateChartInOrgFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update an org
     */
    DirectoryApi.prototype.updateOrgFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
                            throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling updateOrgFromDirectoryController.');
                        }
                        if (requestParameters.orgUpdateRequestDto === null || requestParameters.orgUpdateRequestDto === undefined) {
                            throw new runtime.RequiredError('orgUpdateRequestDto', 'Required parameter requestParameters.orgUpdateRequestDto was null or undefined when calling updateOrgFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/orgs/{orgId}".replace("{".concat("orgId", "}"), encodeURIComponent(String(requestParameters.orgId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OrgUpdateRequestDtoToJSON)(requestParameters.orgUpdateRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OrgResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update an org
     */
    DirectoryApi.prototype.updateOrgFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOrgFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update an resource group
     */
    DirectoryApi.prototype.updateResourceGroupFromDirectoryControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
                            throw new runtime.RequiredError('resourceGroupId', 'Required parameter requestParameters.resourceGroupId was null or undefined when calling updateResourceGroupFromDirectoryController.');
                        }
                        if (requestParameters.resourceGroupUpdateRequestDto === null || requestParameters.resourceGroupUpdateRequestDto === undefined) {
                            throw new runtime.RequiredError('resourceGroupUpdateRequestDto', 'Required parameter requestParameters.resourceGroupUpdateRequestDto was null or undefined when calling updateResourceGroupFromDirectoryController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/directory/resource-groups/{resourceGroupId}".replace("{".concat("resourceGroupId", "}"), encodeURIComponent(String(requestParameters.resourceGroupId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ResourceGroupUpdateRequestDtoToJSON)(requestParameters.resourceGroupUpdateRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ResourceGroupResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update an resource group
     */
    DirectoryApi.prototype.updateResourceGroupFromDirectoryController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateResourceGroupFromDirectoryControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return DirectoryApi;
}(runtime.BaseAPI));
exports.DirectoryApi = DirectoryApi;
/**
 * @export
 */
exports.ListMyAccessibleChartsInAnOrgFromDirectoryControllerSortDateAppointmentPretestEnum = {
    Asc: 'asc',
    Desc: 'desc'
};
